module.exports = __webpack_public_path__ + "static/img/IB2logo_3.c55d77c3.png";